module.exports = __webpack_public_path__ + "img/classify-item4-active.40eea940.png";